import { useCallback, useState } from 'react'

import { apPoExportPromoDismissalRepository } from '@webapp/platform/discover-more/data-access/repositories/ApPoExportPromoDismissalRepository'

export const useApPoExportPromoDismissal = () => {
  const [isDismissed, setIsDismissed] = useState(() =>
    apPoExportPromoDismissalRepository.isDismissed()
  )

  const dismiss = useCallback(() => {
    apPoExportPromoDismissalRepository.dismiss()
    setIsDismissed(true)
  }, [])

  return { isDismissed, dismiss }
}
